import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

import { Exhibit } from '../firestore-models/exhibit';
import { ExhibitRanking } from '../firestore-models/exhibit-ranking';
import { ExhibitAttribute } from '../firestore-models/exhibit-attribute';
import { ProjectLanguage } from '../firestore-models/project-language';

import { ConfigurationService } from '../configuration.service';
import { AppConst } from '../app-const';

@Component({
  selector: 'app-exhibit-rankings',
  templateUrl: './exhibit-rankings.component.html',
  styleUrls: ['./exhibit-rankings.component.css'],
  standalone: false,
})
export class ExhibitRankingsComponent implements OnInit, OnDestroy {

  //Exhibitコレクション
  private exhibitsCollection!: AngularFirestoreCollection<Exhibit>;
  exhibitsObservable!: Observable<Exhibit[]>;
  exhibitsSubscribe!: Subscription;
  private exhibitRankingsCollection!: AngularFirestoreCollection<ExhibitRanking>;
  exhibitRankingsObservable!: Observable<ExhibitRanking[]>;
  exhibitRankingsSubscribe!: Subscription;
  private exhibitAttributesCollection!: AngularFirestoreCollection<ExhibitAttribute>;
  exhibitAttributesObservable!: Observable<ExhibitAttribute[]>;
  exhibitAttributesSubscribe!: Subscription;
  //各展示情報に紐付くプロジェクトID
  projectId: string;
  //各展示情報に紐付くプロジェクトの言語情報
  projectLanguages!: Array<ProjectLanguage>;

  //展示情報テーブル
  displayedColumns: string[] = ['position', 'count', 'exhibit_id', 'attribute', 'name', 'file', 'date'];
  dataSource = new MatTableDataSource<any>();

  protected ATTR_SEARCH_WORD_PREFIX: string = 'exhibitAttributes';
  exhibits?: Array<any>;
  exhibitRankings?: Array<ExhibitRanking>;
  exhibitAttributes!: Array<ExhibitAttribute>;

  searchFilter: any = {};

  uploadedFilesCollectionName = AppConst.FIRESTORE_UPLOADED_FILES;

  projectBaseLang: string = 'ja';

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    // 展示物取得
    this.exhibitsCollection = this.angularFirestore.collection<Exhibit>(
      AppConst.FIRESTORE_EXHIBITS, ref => ref.where('project_id', '==', this.projectId).orderBy('exhibit_id', 'asc'));
    this.exhibitsObservable = this.exhibitsCollection.valueChanges({ idField: 'id' });
    this.exhibitsSubscribe = this.exhibitsObservable.subscribe(exhibits => {
      this.exhibits = exhibits;
      this.exhibitAddCount();
    });
    // 展示ランキング取得
    this.exhibitRankingsCollection = this.angularFirestore.collection<ExhibitRanking>(
      AppConst.FIRESTORE_EXHIBIT_RANKINGS, ref => ref.where('project_id', '==', this.projectId).orderBy('count', 'desc'));
    this.exhibitRankingsObservable = this.exhibitRankingsCollection.valueChanges({ idField: 'id' });
    this.exhibitRankingsSubscribe = this.exhibitRankingsObservable.subscribe(exhibitRankings => {
      this.exhibitRankings = exhibitRankings;
      this.exhibitAddCount();
    });
    // 展示属性取得
    this.exhibitAttributesCollection = this.angularFirestore.collection<ExhibitAttribute>(
      AppConst.FIRESTORE_EXHIBIT_ATTR, ref => ref.where('project_id', '==', this.projectId).orderBy('attribute_id', 'asc'));
    this.exhibitAttributesObservable = this.exhibitAttributesCollection.valueChanges({ idField: 'id' });
    this.exhibitAttributesSubscribe = this.exhibitAttributesObservable.subscribe(exhibitAttributes => {
      this.exhibitAttributes = exhibitAttributes;
    });
  }

  ngOnDestroy(): void {
    this.exhibitsSubscribe.unsubscribe();
    this.exhibitRankingsSubscribe.unsubscribe();
    this.exhibitAttributesSubscribe.unsubscribe();
  }

  // rankingUpdate(): void {
  //   this.exhibitAddCount();
  // }

  async exhibitAddCount() {
    if (!!this.exhibits) {
      for (const exhibit of this.exhibits) {
        exhibit['count'] = 0;
        // 「good_exhibits」から取得
        // const collectionRef = collection(this.angularFirestore.firestore, AppConst.FIRESTORE_GOOD_EXHIBITS);
        // const count = await getCountFromServer(query(collectionRef, where('exhibit_doc_id', '==', exhibit.id), where('good', '==', true)));
        // exhibit['count'] = count.data().count;
        // 「exhibit_rankings」から取得
        if (!!this.exhibitRankings) {
          for (const exhibitRankings of this.exhibitRankings) {
            if (exhibit.id == exhibitRankings.id) {
              exhibit['count'] = exhibitRankings.count;
              break;
            }
          }
        }
      }
      this.exhibits = this.exhibits.sort(function(a:any, b:any) {
        return (a.count > b.count) ? -1 : 1;
      });

      this.dataSource = new MatTableDataSource(this.exhibits);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

}
